<template>
    <div v-if="showWarrantySection" class="my-4">
        <p class="h5 mb-4">Chọn dịch vụ bảo hành</p>
        <div class="warranty-select">
            <div v-if="services.length" class="warranty-select__grid">
                <button
                    v-for="(service, index) in services"
                    :key="getServiceKey(service, index)"
                    type="button"
                    class="warranty-select__card"
                    :class="{
                        'warranty-select__card--selected': isSelected(service.id),
                        'warranty-select__card--disabled': disabled,
                    }"
                    :disabled="disabled"
                    @click="handleSelect(service)"
                >
                    <div class="warranty-select__title">{{ service.name }}</div>
                    <div v-if="!service.hideCost" class="warranty-select__subtitle">
                        {{ getCostText(service.percent) }}
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { isWarrantyServiceCenter } from "@/core/config/center/centerOption";

export default {
    name: "WarrantySelect",
    props: {
        centerId: {
            type: [Number, String],
            default: null,
        },
        services: {
            type: Array,
            default: () => [],
        },
        selectedId: {
            type: [Number, String],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        showWarrantySection() {
            const id = this.centerId;
            if (id === null || id === undefined || id === "") {
                return false;
            }
            return isWarrantyServiceCenter(id);
        },
    },
    watch: {
        selectedId: {
            immediate: true,
            handler(newValue) {
                if (!this.services.length) {
                    return;
                }

                this.syncSelectedService(newValue);
            },
        },
        services: {
            handler() {
                this.syncSelectedService(this.selectedId);
            },
            deep: true,
        },
    },
    methods: {
        syncSelectedService(selectedId) {
            if (selectedId !== undefined) {
                console.log('selectedId', selectedId);
                this.emitSelectedService(selectedId);
                return;
            }

            const defaultService = this.services.find((item) => item.percent === 0);

            if (defaultService) {
                this.$emit("selected", defaultService);
            }
        },
        handleSelect(service) {
            if (this.disabled) {
                return;
            }

            this.$emit("selected", service);
        },
        emitSelectedService(id) {
            const selectedService = this.services.find((item) => {
                const isLegacyItem = item.id === null;
                const isLegacyId = id === null || id === 0 || id === "0";

                if (isLegacyItem || isLegacyId) {
                    return isLegacyItem && isLegacyId;
                }

                return Number(item.id) === Number(id);
            });

            if (selectedService) {
                this.$emit("selected", selectedService);
            }
        },
        isSelected(id) {
            if (id === null || this.selectedId === null) {
                return id === this.selectedId;
            }

            return Number(this.selectedId) === Number(id);
        },
        getServiceKey(service, index) {
            return service.id === null ? "legacy-warranty-service" : service.id || index;
        },
        getCostText(percent) {
            if (percent === 0) {
                return "0 đ";
            }

            return percent + "% tổng giá khóa";
        },
    },
};
</script>

<style scoped>
.warranty-select__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
}

.warranty-select__card {
    width: 100%;
    min-height: 72px;
    padding: 12px 16px;
    border: 1px solid #d9deea;
    border-radius: 14px;
    background: #fbfcff;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease,
        transform 0.2s ease;
}

.warranty-select__card:not(.warranty-select__card--selected):hover {
  border-color: #b9c8e6;
  background: #f7faff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}

.warranty-select__card--disabled {
  cursor: not-allowed;
}

.warranty-select__card--disabled:not(.warranty-select__card--selected):hover {
  border-color: #d9deea;
  background: #fbfcff;
  box-shadow: none;
  transform: none;
}

.warranty-select__card--selected {
    border-color: #005BBF;
    background: #f2f7ff;
    border-width: 2px;
    box-shadow: 0 2px 8px rgba(0, 91, 191, 0.15);
}

.warranty-select__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.45;
    color: #2f3a4c;
}

.warranty-select__subtitle {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.45;
    color: #7a8599;
}

@media (max-width: 768px) {
    .warranty-select__grid {
        grid-template-columns: 1fr;
    }
}
</style>
